const CONSTANTS = {
  BANKS: {
    DRAFT: 'Rascunho',
  },
};

export default CONSTANTS;
